import { useCurrentUserQuery } from './useCurrentUserQuery';

export function useExternalServiceProvider() {
  const { data: currentUser } = useCurrentUserQuery();

  const isEspRole = currentUser?.role?.dashboardType === 'external_service_provider';
  /** All ESP-role users use the dedicated portal; multi-company switching is handled inside the portal (SelectedCompany + navbar). */
  const isExternalServiceProvider = Boolean(isEspRole);

  return {
    isExternalServiceProvider,
    currentUser,
  };
}
